import { InvoicesService } from '../../services/invoices.service';
import { SuccessModal } from '../../app.model';
import { SuccessModalComponent } from '../../components/success-modal/success-modal.component';
import { bulkInvoice } from '../../app.constant';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

export abstract class BaseInvoicesComponent {
    public loading = false;
    public selectedInvoices: any[] = [];
    public modalRef!: NgbModalRef;
    public error!: string;

    abstract invoiceType: string;

    constructor(
        public invoicesService: InvoicesService,
        public activeModalService: NgbActiveModal,
        public modalService: NgbModal
    ) { }


    toggleInvoiceSelection(invoice: any, event: any) {
        if (event.target.checked) {
            if (this.selectedInvoices.length < bulkInvoice.MAX_PROCESSING) {
                this.selectedInvoices.push(invoice);
            }
        } else {
            this.selectedInvoices = this.selectedInvoices.filter(inv => inv.uuid !== invoice.uuid);
        }
    }

    isSelected(invoice: any): boolean {
        return this.selectedInvoices.some(inv => inv.uuid === invoice.uuid);
    }

    isDisabled(invoice: any): boolean {
        return this.selectedInvoices.length >= bulkInvoice.MAX_PROCESSING && !this.isSelected(invoice);
    }

    sendSelectedInvoices() {
        if (this.selectedInvoices.length === 0) {
            alert("Please select at least one invoice.");
            return;
        }

        this.loading = true;
        const invoiceIds = this.selectedInvoices.map(inv => inv.uuid);
        const payload = { invoice_type: this.invoiceType };

        this.invoicesService.sendInvoices(invoiceIds, payload).subscribe({
            next: (response) => {
                this.loading = false;
                this.selectedInvoices = [];
                this.refreshInvoices();   // instead of ngOnInit()
                this.successModal(response.message);
            },
            error: (err) => {
                this.loading = false;
                this.error = err;
            }
        });
    }

    successModal(message: string) {
        this.modalRef = this.modalService.open(SuccessModalComponent, {
            size: 'sm',
            modalDialogClass: 'success-modal',
            backdrop: false,
        });
        let data: SuccessModal = {
            message: message,
            image: 'assets/img/checkmark.png',
            duration: 3000,
        };
        this.modalRef.componentInstance.data = data;
        this.modalRef.result.then((data) => {
            if (data?.action === 'yes') {
                this.activeModalService.close();
            }
        });
    }


    protected abstract refreshInvoices(): void;
}
